import React from 'react';
import { useFirestoreDocs } from '../hooks/useFirestoreDocs';
import MarkdownRenderer from '../components/MarkdownRenderer';

/**
 * Vista Dinámica de Documentación para Clientes Finales & Destinatarios
 */
export default function ClientDocs() {
  const { docs, loading } = useFirestoreDocs('clientes');

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', fontWeight: 300 }}>
        Cargando guía de clientes y destinatarios...
      </div>
    );
  }

  return (
    <div className="client-docs-container">
      {docs.map((docItem) => (
        <section key={docItem.id} id={docItem.id} className="doc-section" style={{ marginBottom: '2.5rem' }}>
          <MarkdownRenderer content={docItem.contenidoMarkdown} />
        </section>
      ))}
    </div>
  );
}
